export const getRelativeLink = (url: string): string => {
    const appUrl = process.env.REACT_APP_DOMAIN ? process.env.REACT_APP_DOMAIN : '';
    return url.replace(appUrl, '');
}